import React, { useContext, useEffect, useState, Fragment } from 'react';
import { useParams, Link } from "react-router-dom";

import ModuleCheckbox from '../components/ModuleCheckbox';
import CardProfile from '../components/CardProfile';
import Tile from '../components/Tile';
import ModuleDocument from '../components/ModuleDocument';
import UploadField from '../components/UploadField';
import { useForm } from 'react-hook-form';

import { AppContext } from '../../App';
import { getMediaFilePath } from '../../functions/get-media-file-path';

const AssessmentDocument = ({ courseStudent, assessment, handleDocumentUploadChange }) => {
  const { register, handleSubmit, setValue, watch, reset, formState: { errors } } = useForm();
  const appContext = useContext(AppContext);
  const [isFileSelected, setIsFileSelected] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [studentAssessment, setStudentAssessment] = useState(courseStudent.assessments.find(a => a.courseModuleAssessmentId == assessment.courseModuleAssessmentId) || {})
  console.log(assessment)
  console.log(courseStudent)
  //const courseModuleDeadline = new Date(courseModule.moduleDeadline);
  //const today = new Date();

  const handleUploadAssessment = async (data) => {
    console.log("Selected file:", data.assessment.file);
    const selectedFile = data.assessment.file;
    if (!selectedFile) return;
  
    try {
      const response = await appContext.httpClient.post({
        path: "assessment/submit",
        body: {
          courseModuleAssessmentId: assessment.courseModuleAssessmentId,
          assessmentPaper: selectedFile,
          courseStudentId: courseStudent.courseStudentId
        }
      });

      debugger;
      
      console.log("Upload response:", response); // Check response here
      if (response.success) {
        reset({
          assessment: response.result
        });
        setStudentAssessment(response.result);
        setUploadSuccess(true);
        setIsFileSelected(false);
      } else {
        console.error("Upload failed - response.success was false");
      }
    } catch (error) {
      console.error("Upload failed:", error); // Log errors
    }
  };

  const handleFileChange = (event) => {
    if (event.target.info?.succeeded && event.target.info?.filename) {
      setIsFileSelected(true);
    } else {
      setIsFileSelected(false);
    }
    setUploadSuccess(false);
  };

  console.log(studentAssessment)

  return (
    <div className="flex flex-col relative mb-12">
      <div className="w-full p-6 bg-brandDarkBlue">
          <h2 className="section-title text-1xl text-white font-bold">{assessment.assessmentTitle}</h2>
      </div>
      <form onSubmit={handleSubmit(handleUploadAssessment)}>
        <div className="py-6 px-6 bg-white">
          <ModuleDocument
            name={assessment.file.filename}
            type={assessment.file.fileExtension.replace('.', '')}
            link={`https://insol.azureedge.net/cmsstorage/insol/media/education/${assessment.file.path.toLowerCase()}`}
          />
          <h3 className="text-brandMidBlue text-lg font-bold mb-4 block">Your uploaded assessment</h3>
          <UploadField 
            name={`assessment.file`}
            setValue={setValue}
            register={register}
            defaultFile={{
              ...studentAssessment,
              type: studentAssessment.resubmittedAssessmentPaper ? "RESUBMITTED_PAPER" : "PAPER"
            }}
            onChange={handleFileChange}
          />
          {uploadSuccess && (
          <div className="flex items-center bg-green p-3  text-sm mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-3" viewBox="0 0 16 16">
              <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
            </svg>
            <span>Assessment upload successful</span>
          </div>
          )}
          <button 
            disabled={!isFileSelected}
            className={`${isFileSelected ? "bg-brandRed" : "bg-brandGrey"} hover:bg-blue-700 text-white font-medium py-2 px-6 mb-6 rounded-md self-start w-full`}>
              Save document
          </button>
          {studentAssessment && studentAssessment.markedPaper && (
          <div className="mb-3">
            <h3 className="text-brandMidBlue text-lg font-bold mb-4 block">Your marked assessment</h3>
            {studentAssessment && studentAssessment.markedPaper && studentAssessment.markedPaper.path ? (
                <>
                  <a className="flex bg-uiUpload p-3 text-xs border-solid border border-uiUploadBorder text-kenticoblue underline" href={`${getMediaFilePath(studentAssessment, "MARKED_PAPER").url}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-3" viewBox="0 0 16 16">
                    <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                  </svg>
                    View your marked assessment
                  </a>
                </>
            ) : null}
            {studentAssessment && studentAssessment.resubmittedAssessmentPaper && studentAssessment.resubmittedAssessmentPaper.path ? (
                <>
                  <a className="flex bg-uiUpload p-3 text-xs border-solid border border-uiUploadBorder text-kenticoblue underline" href={`${getMediaFilePath(studentAssessment, "RESUBMITTED_MARKED_PAPER")?.url}`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-3" viewBox="0 0 16 16">
                    <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z"/>
                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                  </svg>
                    View your resubmitted marked assessment
                  </a>
                </>
            ) : null}
          </div>
          )}
        </div>
      </form>
    </div>
  );
};

const Module = (props) => {
  const { page, courses } = props;
  const { action, courseId, moduleId, section } = useParams();
  const [course, setCourse] = useState([]);
  const [courseStudent, setCourseStudent] = useState(null);
  const appContext = useContext(AppContext);
  const [content, setContent] = useState(null);
  const [courseModule, setCourseModule] = useState(null);
  const [isFileSelected, setIsFileSelected] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState(null);

  useEffect(() => {
    appContext.httpClient.post({
      path: "coursestudent",
      authRedirectPath: appContext.loginPath,
      body: {
        courseId
      }
    }).then(response => {
        console.log(response)
        if (response.success && response.result) {
            setCourseStudent(response.result)
            console.log(response.result)
        }
    });

    appContext.httpClient.get({
      path: "course/subcontent/" + courseId,
      authRedirectPath: appContext.loginPath
    })
    .then(response => {
        if (response.success && response.result) {
            console.log(response.result)
            setContent(response.result)
        }
    });

    appContext.httpClient.get({
      path: "course/" + courseId,
      authRedirectPath: appContext.loginPath
    }).then(response => {
        //debugger;
        console.log(response.result)
        if (response.result) {  
          console.log(response.result);
          const courseData = response.result;
          courseData.courseLogo = appContext.fileBaseUrl + courseData.courseLogo.replace(/^~/, '');
          courseData.courseBrochureCoverImage = appContext.fileBaseUrl + courseData.courseBrochureCoverImage.replace(/^~/, '');
          courseData.courseHandbookCoverImage = appContext.fileBaseUrl + courseData.courseHandbookCoverImage.replace(/^~/, '');
          setCourse(courseData);

          console.log(response.result.moduleGroups)
          const moduleGroups = response.result.moduleGroups
          
          for (const group of moduleGroups) {
            console.log(group)
            const module = group.modules.find(mod => mod.courseModuleId === parseInt(moduleId));
            if (module) {
              setCourseModule(module);
              console.log(courseModule)
              break;
            }
          }

        }
    });

  }, [appContext.apiBaseUrl, moduleId]);

  const formatDate = (dateString) => {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  
  const handleDocumentUploadChange = (assessmentId, event) => {
    const newDoc = {
        file: event.target.info
    };
    console.log(newDoc);
    console.log(newDoc.file.uploadId)
    if (newDoc.file.uploadId) {
      setSelectedFiles(prev => ({
        ...prev,
        [assessmentId]: newDoc
      }));
      
      setIsFileSelected(prev => ({
        ...prev,
        [assessmentId]: true
      }));
    }
  }
  
  const handleUploadAssessment = (assessmentId) => {
    console.log(assessmentId)
    console.log(courseStudent.studentId)
    const selectedFile = selectedFiles[assessmentId];
    console.log(selectedFiles[assessmentId].file)
    if (!selectedFile) return;

    appContext.httpClient.post({
      path: "assessment/submit",
      body: {
          courseModuleAssessmentId: assessmentId,
          assessmentPaper: selectedFiles[assessmentId].file,
          courseStudentId: courseStudent.courseStudentId
      }
    })
    .then(response => {
        if (response.success) {
            // not sure if you need anymore data back?
        }
    });
  }

  if (!courseModule || !courseStudent || !course) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      {/* Hero */}
      <section className="hero hero--education relative h-80 bg-gradient-to-r from-darkHero to-lightHero text-white">
        <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <header className="section-header mt-auto mb-10">
            <h2 className="section-title text-4.5xl font-bold">{course.courseTitle}</h2>
          </header>
          {/* Breadcrumbs */}
          <div className="breadcrumbs mb-4 z-10">
            <ul className="flex">
              <li><Link className="white underline" to="/">Home</Link></li>
              <li className="breadcrumb-current">
                <span className="breadcrumb-seperator mx-1">\</span><Link className="white underline" to="/education/v1">Education</Link>
              </li>
              <li className="breadcrumb-current">
                <span className="breadcrumb-seperator mx-1">\</span><span className="text-fontColor">{course.courseTitle}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex absolute top-0 left-0 right-0 bottom-0 z-0">
          <img className="object-cover lg:object-contain lg:object-right ml-auto" src="https://insol.azureedge.net/cmsstorage/insol/media/heros/hero-arrow-education.png" alt="" />
        </div>
      </section>

      {/* My Courses */}
      <section className="courses py-8 lg:py-12">
            <div className="container flex flex-col h-full gap-12 mx-auto max-w-540 md:max-w-640 lg:flex-row lg:max-w-992 xl:max-w-90rem p-4">
              <aside className="flex flex-col relative lg:w-450">

                <div className="flex flex-col relative mb-12">
                    <div className="w-full p-6 bg-brandDarkBlue">
                        <h2 className="section-title text-1xl text-white font-bold">Course content</h2>
                    </div>
                    <div className="bg-brandGrey">
                        {course.moduleGroups && course.moduleGroups.map((group, index) => (
                          <Fragment key={index}>
                            {group.modules && group.modules.map((module, moduleIndex) => (
                              <Link key={moduleIndex} to={`../course/${courseId}/module/${module.courseModuleId}`}>
                              <ModuleCheckbox
                                  label={module.moduleName}
                                  type="checkbox"
                                  moduleId={module.courseModuleId}
                                  active={parseInt(moduleId) === module.courseModuleId}
                                  //status="passed"
                              />
                              </Link>
                            ))}
                          </Fragment>
                        ))}
                    </div>
                </div>

                <div className="flex flex-col relative mb-12">
                    <div className="w-full p-6 bg-brandDarkBlue">
                        <h2 className="section-title text-1xl text-white font-bold">Module documentation</h2>
                    </div>
                    <div className="pt-6 px-6 bg-brandGrey">
                        {courseModule.documents.map((document, documentIndex) => (
                          <ModuleDocument
                            key={documentIndex}
                            name={document.file.filename}
                            type={document.file.fileExtension.replace('.', '')}
                            link={`https://insol.azureedge.net/cmsstorage/insol/media/education/${document.file.path.toLowerCase()}`}
                          />
                        ))}
                    </div>
                </div>

              </aside>

              <div className="flex-1">
                <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">{courseModule.moduleName}</h1>
                <div className="module__introduction" dangerouslySetInnerHTML={{ __html: courseModule.moduleDescription }} />
                <div className="video__container">
                    <iframe src={courseModule.videoURL} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen=""></iframe>
                </div>
              </div>
          </div>
      </section>
      
      {courseModule?.assessments?.length > 0 && (
      <section className="courses py-8 lg:py-12 bg-brandGrey">
      <div className="container flex flex-col h-full gap-12 mx-auto max-w-540 md:max-w-640 lg:flex-row lg:max-w-992 xl:max-w-90rem p-4">
              <aside className="flex flex-col relative lg:w-450">

                {courseModule.moduleDeadline && (
                <div className="flex flex-col relative mb-12">
                    <div className="w-full p-6 bg-brandDarkBlue">
                        <h2 className="section-title text-1xl text-white font-bold">Deadline</h2>
                    </div>
                    <div className="p-6 bg-white">
                        <span className="text-brandMidBlue mb-4">{formatDate(courseModule.moduleDeadline)}</span>
                    </div>
                </div>
                )}

                {courseModule.assessments.map((assessment, assessmentIndex) => (
                  <AssessmentDocument 
                    key={assessmentIndex}
                    assessment={assessment}
                    handleUploadAssessment={handleUploadAssessment}
                    handleDocumentUploadChange={handleDocumentUploadChange}
                    courseStudent={courseStudent}
                  />
                ))}
                
                {/*courseModule.assessments.map((assessment, assessmentIndex) => (
                  <div className="flex flex-col relative mb-12">
                    <div className="w-full p-6 bg-brandDarkBlue">
                        <h2 className="section-title text-1xl text-white font-bold">Assessment document {assessmentIndex + 1}</h2>
                    </div>
                    <div className="pt-6 px-6 bg-white">
                        <ModuleDocument
                          name={assessment.file.filename}
                          type={assessment.file.fileExtension.replace('.', '')}
                          link={`https://insol.azureedge.net/cmsstorage/insol/media/education/${assessment.file.path.toLowerCase()}`}
                        />
                      <h3 className="text-brandMidBlue text-lg font-bold mb-6 block">My uploaded assessment documents</h3>
                      <p className='text-brandMidBlue'>Debugging courseModuleAssessmentId: {assessment.courseModuleAssessmentId}</p>
                      {today < courseModuleDeadline ? (
                        <>
                        <div className="mb-6">
                          <UploadField 
                            name={`assessment.file`}
                            onChange={(event) => handleDocumentUploadChange(assessment.courseModuleAssessmentId, event)}
                          />
                        </div>
                        <button 
                          onClick={() => handleUploadAssessment(assessment.courseModuleAssessmentId)}
                          disabled={!isFileSelected[assessment.courseModuleAssessmentId]}
                          className={`${isFileSelected[assessment.courseModuleAssessmentId] ? "bg-brandRed" : "bg-brandGrey"} hover:bg-blue-700 text-white font-medium py-2 px-6 mb-6 rounded-md self-start w-full`}>
                            Save document
                        </button>
                        </>
                      ) : (
                        <>
                        <div className="mb-6">
                          <UploadField 
                            name={`assessment.file`}
                            onChange={(event) => handleDocumentUploadChange(assessment.courseModuleAssessmentId, event)}
                          />
                        </div>
                        <div className="mb-6">
                          <button type="button" className="border-2 border-brandDarkBlue text-brandDarkBlue font-medium py-2 px-6 rounded-md self-start cursor-default" style={{ border: '2px solid #172B46 !important' }}>
                            Sorry, the deadline for this module has passed.
                          </button>
                        </div>
                        </>
                      )}
                    </div>
                  </div>
                ))*/}
              </aside>

              <div className="flex-1">
                <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Module assessment</h1>
                <div className="module__introduction text-brandMidBlue" dangerouslySetInnerHTML={{ __html: courseModule.assessmentInformation }} />
              </div>
          </div>
      </section>
      )}

    </div>
  );
};

export default Module;